import React from 'react';

export const FormErrors = ({formErrors}) =>
  <div className="form-group help-block show has-error">
    <div className='formErrors has-error help-block'>

      {Object.keys(formErrors).map((fieldName, i) => {
        if(formErrors[fieldName].length > 0){
          return (
            <p key={i} dangerouslySetInnerHTML={monkeys(formErrors[fieldName])} ></p>
          )
        } else {
          return '';
        }
      })}
    </div>
  </div>
  function monkeys(formErrors){
    return {__html: formErrors};
  }



// WEBPACK FOOTER //
// ./src/FormErrors.js